import React from 'react';
import styled from 'styled-components';

const tableData = [
  {
    column_number: 1,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_survey_production_lot_drug_id',
    source_column_name: 'lot',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 2,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_survey_production_lot_id',
    source_column_name: 'csb_survey_production_lot_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 3,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_survey_main_id',
    source_column_name: 'csb_survey_main_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 4,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_record_group_id',
    source_column_name: 'csb_record_group_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 5,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_account_id',
    source_column_name: 'csb_account_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 6,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_survey_production_lot_upload_id',
    source_column_name: 'csb_survey_production_lot_upload_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 7,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_template_id',
    source_column_name: 'csb_pl_template_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 8,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_ordinal',
    source_column_name: 'csb_pl_drug_ordinal',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 9,
    target_column_classify_field_setup: 'Setup Lookup Field (2)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_route_id',
    source_column_name: 'route',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 10,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'varchar(192)',
    target_column_name: 'csb_pl_source_drug_name',
    source_column_name: 'active_ingredient',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 11,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_source_drug_value',
    source_column_name: 'total_mg',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 12,
    target_column_classify_field_setup: 'Setup Lookup Field (2)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_source_drug_value_units_id',
    source_column_name: 'unit',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 13,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Trade Name (2)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_trade_name_id (TnId=)', // Note: This target_column_name has special characters
    source_column_name: 'csb_pl_drug_trade_name_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 14,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Active Ingredient (1)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_active_ingredient_id (AiId=)', // Note: This target_column_name has special characters
    source_column_name: 'active_ingredient',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 15,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_drug_total_mg',
    source_column_name: 'total_mg',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 16,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_drug_total_ml',
    source_column_name: 'csb_pl_drug_total_ml',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 17,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_pl_drug_regimen_id',
    source_column_name: 'csb_pl_drug_regimen_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 18,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'bigint',
    target_column_name: 'csb_pl_drug_regimen_detail_id',
    source_column_name: 'csb_pl_drug_regimen_detail_id',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 19,
    target_column_classify_field_setup: 'Setup Lookup Field (2)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_primary_reason_for_use',
    source_column_name: 'tm',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 20,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_drug_primary_reason_for_use_pct_gp',
    source_column_name: 'csb_pl_drug_primary_reason_for_use_pct_gp',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 21,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dp',
    source_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dp',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 22,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'numeric',
    target_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dt',
    source_column_name: 'csb_pl_drug_primary_reason_for_use_pct_dt',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 23,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_secondary_reason_respiratory',
    source_column_name: 'primary_use_reason',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 24,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_secondary_reason_digestive',
    source_column_name: 'csb_pl_drug_secondary_reason_digestive',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 25,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_secondary_reason_lameness',
    source_column_name: 'csb_pl_drug_secondary_reason_lameness',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 26,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_secondary_reason_neurologic',
    source_column_name: 'csb_pl_drug_secondary_reason_neurologic',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 27,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_secondary_reason_liver_abscess',
    source_column_name: 'csb_pl_drug_secondary_reason_liver_abscess',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 28,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_secondary_reason_coccidiosis',
    source_column_name: 'csb_pl_drug_secondary_reason_coccidiosis',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 29,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_secondary_reason_enteritis',
    source_column_name: 'csb_pl_drug_secondary_reason_enteritis',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 30,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_secondary_reason_mixed',
    source_column_name: 'csb_pl_drug_secondary_reason_mixed',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 31,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'varchar(128)',
    target_column_name: 'csb_pl_drug_secondary_reason_mixed_description',
    source_column_name: 'csb_pl_drug_secondary_reason_mixed_description',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 32,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'integer',
    target_column_name: 'csb_pl_drug_secondary_reason_other',
    source_column_name: 'csb_pl_drug_secondary_reason_other',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 33,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'varchar(128)',
    target_column_name: 'csb_pl_drug_secondary_reason_other_description',
    source_column_name: 'csb_pl_drug_secondary_reason_other_description',
    column_not_used: 'Not Used (1)',
  },
  {
    column_number: 34,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'varchar',
    target_column_name: 'csb_pl_drug_secondary_reason_source',
    source_column_name: 'primary_use_reason',
    column_not_used: 'Used (0)',
  },
  {
    column_number: 35,
    target_column_classify_field_setup: 'Setup Standard Field (1)',
    target_field_category: 'Core Field (0)',
    target_column_type: 'varchar',
    target_column_name: 'csb_pl_drug_notes',
    source_column_name: 'csb_pl_drug_notes',
    column_not_used: 'Not Used (1)',
  },
];

const TableWrapper = styled.div`
  overflow-x: auto; /* Enables horizontal scrolling for small screens */
  margin-top: 2em; /* Added margin above the table */
  margin-bottom: 2em;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  /*table-layout: fixed; Maintains column widths */
  font-size: 0.9em; /* Slightly smaller font for tables */
  min-width: 1200px; /* Set a minimum width for the table to prevent squishing */
  color: ${({ theme }) => theme.text}; 
`;

const TableHeader = styled.th`
  padding: 8px;
  border: 1px solid #999;
  text-align: left;
  font-weight: bold;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.headerBg}; /* Use theme for header background */
  color: ${({ theme }) => theme.headerText}; /* Use theme for header text color */
  position: sticky; /* Make headers sticky */
  top: 0; /* Stick to the top when scrolling */
  z-index: 1; /* Ensure headers appear above scrolling content */
`;

const TableCell = styled.td`
  padding: 8px;
  border: 1px solid #ddd;
  text-align: left;
  height: 15pt; /* Original height */
  /* Align column_number to the right */
  &:nth-child(1) {
    text-align: right;
  }
`;

const TableRow = styled.tr`
  &:nth-child(even) { /* Apply a different background to even rows */
  
  }
`;

const FeedDrugTemplateTable = () => {
  return (
    <TableWrapper>
      <h4>Drug Template: Feed Drug Template Fields</h4> {/* Changed to h4 to match SectionTitle */}
      <StyledTable>
        <thead>
          <tr>
            <TableHeader>column_number</TableHeader>
            <TableHeader>target_column_classify_field_setup</TableHeader>
            <TableHeader>target_field_category</TableHeader>
            <TableHeader>target_column_type</TableHeader>
            <TableHeader>target_column_name</TableHeader>
            <TableHeader>source_column_name</TableHeader>
            <TableHeader>column_not_used</TableHeader>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.column_number}</TableCell>
              <TableCell>{row.target_column_classify_field_setup}</TableCell>
              <TableCell>{row.target_field_category}</TableCell>
              <TableCell>{row.target_column_type}</TableCell>
              <TableCell>{row.target_column_name}</TableCell>
              <TableCell>{row.source_column_name}</TableCell>
              <TableCell>{row.column_not_used}</TableCell>
            </TableRow>
          ))}
        </tbody>
      </StyledTable>
    </TableWrapper>
  );
};

export default FeedDrugTemplateTable;